<style lang="less">
    .schedule-block{
        border-bottom:1px solid #ccc ;
        .schedule-date{
            font-weight: bold;
        }

        .schedule-time{

        }

        &:last-child{
            border-bottom:0px;
        }
    }
</style>
<template>
    <div>
        <Table :columns="columns" :data="data">
            <template slot-scope="{ row, index }" slot="courseName">
                {{row.courseName}}
                <span v-if="row.classState == 3" style="color:red">（已结课）</span>
            </template>
            <template slot-scope="{ row, index }" slot="scheduleList">
                <div class="schedule-block" v-for="schedule in row.scheduleList" v-if="row.scheduleList != undefined">
                    <div class="schedule-date">
                        {{schedule.begin_date|dateFilter}} 至 {{schedule.end_date|dateFilter}}&nbsp;已排{{schedule.remain_num}}次课
                    </div>
                    <div class="schedule-time" v-for="time in schedule.timeList">
                        {{time.start}}-{{time.end}}({{time.weekday|weekDayFilter}})
                    </div>
                </div>
            </template>
            <template slot-scope="{ row, index }" slot="op">
                <Button type="primary" size="small" @click="transfer(row, index)" v-if="row.class_num_remain>0" style="margin-right: 5px;">课程变更</Button>
                <Button type="primary" size="small" @click="changeNum(row, index)" v-if="$store.state.user.isadmin == 1 || $store.state.user.isHoAdmin" style="margin-right: 5px;">增减课时</Button>
                <Button type="primary" size="small" @click="finishClass(row, index)" v-if="row.classState == 1 || row.classState === undefined" style="margin-right: 5px;">结课</Button>
            </template>
        </Table>
        <Modal v-model="showTransfer" title="课程变更" width="800">
            <Form :model="transferForm" :label-width="100" ref="transferForm"
                  :rules="transferFormValidate"
                  @keyup.enter.native="transferHandleSubmit()">
                <FormItem label="原课程"  >
                    {{transferForm.oldCourseName}}
                </FormItem>
                <FormItem label="变动课时数"  >
                    {{transferForm.num}}
                </FormItem>
                <FormItem label="新课程" prop="newCourseId" >
                    <Select v-model="transferForm.newCourseId" filterable style="width: 250px" clearable>
                        <Option v-for="item in courseList" :value="item.id" :key="item.id">{{ item.name}}({{ item.type | courseTypeFilter }})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="备注" prop="remark" >
                    <Input v-model="transferForm.remark" placeholder="" ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="transferModalCancel">取消</Button>
                <Button type="primary" size="large" @click="transferHandleSubmit()" :loading="transferForm.saving">
                    确定
                </Button>
            </div>
        </Modal>
        <Modal v-model="showChangeNum" title="增减课时" width="800">
            <Form :model="changeNumForm" :label-width="100" ref="changeNumForm"
                  :rules="changeNumFormValidate"
                  @keyup.enter.native="changeNumHandleSubmit()">
                <FormItem label="课程"  >
                    {{changeNumForm.courseName}}
                </FormItem>
                <FormItem label="课时数" prop="num" >
                    <Input v-model="changeNumForm.num" placeholder="正数为加课时，负数为减课时" />
                </FormItem>
                <FormItem label="原因" prop="changeReason" v-if="changeNumForm.num < 0">
                    <Select v-model="changeNumForm.changeReason">
                        <Option :value="1">补扣上课课时（纳入学员上课消课）</Option>
                        <Option :value="2">其他（不纳入上课消课）</Option>
                    </Select>
                </FormItem>
                <FormItem label="备注" prop="remark" >
                    <Input v-model="changeNumForm.remark" placeholder="" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="changeNumModalCancel">取消</Button>
                <Button type="primary" size="large" @click="changeNumHandleSubmit()" :loading="changeNumForm.saving">
                    确定
                </Button>
            </div>
        </Modal>
    </div>
</template>
<script>
  export default {
    name: 'clazz',
    data() {
      return {
        showTransfer:false,
        transferForm:{
          oldCourseId:null,
          oldCourseName:null,
          newCourseId:null,
          num:null,
          remark:null,
          saving:false
        },
        transferFormValidate:{
          newCourseId: [
            { required: true, type: 'number',message: '请选择课程', trigger: 'blur' }
          ],
          remark: [
            { required: true, message: '请输入备注', trigger: 'blur' }
          ],
        },
        columns: [
          {
            title: '课程',
            slot: 'courseName',
            align: 'center',
            width:280
          },
          {
            title: '校区',
            key: 'zoneName',
            align: 'center'
          },
          {
            title: '剩余课时',
            key: 'class_num_remain',
            align: 'center'
          },
          {
            title: '已用课时',
            key: 'class_num_used',
            align: 'center'
          },
          {
            title: '购买课时',
            key: 'class_num_buy',
            align: 'center'
          },
          {
            title: '课程安排',
            slot: 'scheduleList',
            width:250
          },
          {
            title: '操作',
            slot: 'op',
            width:230
          }
        ],
        data: [],
        showChangeNum:false,
        changeNumForm:{
          courseName:null,
          classBuyId:null,
          changeReason:1,
          num:null,
          remark:null,
          saving:false
        },
        changeNumFormValidate:{
          num: [
            { required: true, message: '请输入数量', trigger: 'blur' }
          ],
          remark: [
            { required: true, message: '请输入备注', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      getList(){
        this.$api.student.getStudentClassBuyList({
          id:this.$route.query.id
        }).then(resp => {
          this.data = resp.data;
        });
      },
      transfer(row){
        this.transferForm={
          oldCourseId:row.course_id,
          oldCourseName:row.courseName,
          newCourseId:null,
          num:row.class_num_remain,
          remark:null,
          saving:false
        };
        this.showTransfer = true;
      },
      transferHandleSubmit(){
        let self = this;
        self.$refs['transferForm'].validate((valid) => {
          try{
            if (valid) {
              self.transferForm.saving = true;
              self.$api.student.transferClassHour({
                'oldCourseId':self.transferForm.oldCourseId,
                'newCourseId':self.transferForm.newCourseId,
                'num':self.transferForm.num,
                'remark':self.transferForm.remark,
                'studentId':self.$route.query.id
              }).then(resp => {
                self.transferForm.saving = false;
                if (resp.state == 'ok'){
                  self.$Message.info({
                    content:'转移成功',
                    onClose (){
                      self.showTransfer = false;
                      self.getList();
                    }
                  });
                }else{
                  self.$Message.error(resp.msg);
                }
              });
            } else {
              self.$Message.error('表单校验不通过');
            }
          }catch(err){
            console.log(err);
          }
        })
      },
      transferModalCancel(){
        this.showTransfer = false;
      },
      changeNum(row){
        this.changeNumForm={
          courseName:row.courseName,
          classBuyId:row.id,
          changeReason:1,
          num:null,
          remark:null,
          saving:false
        };
        this.showChangeNum = true;
      },
      finishClass(row){
        let self = this;
        self.$Modal.confirm({
          title: '确认操作',
          content: '确认要执行结课操作吗?将清空该学员本门课程的课时和已经排的课程',
          onOk() {
            this.$api.student.finishClass({classBuyId: row.id}).then(res => {
              if (res.state == "ok") {
                self.$Message.success("结课操作成功")
                self.getList();
              } else {
                self.$Message.error(res.msg)
              }
            })
          },
          onClose() {
          }
        })
      },
      changeNumHandleSubmit(){
        let self = this;
        self.$refs['changeNumForm'].validate((valid) => {
          try{
            if (valid) {
              self.changeNumForm.saving = true;
              self.$api.student.changeClassHourNum({
                'classBuyId':self.changeNumForm.classBuyId,
                'num':self.changeNumForm.num,
                'remark':self.changeNumForm.remark,
                changeReason:self.changeNumForm.changeReason
              }).then(resp => {
                self.changeNumForm.saving = false;
                if (resp.state == 'ok'){
                  self.$Message.info({
                    content:'操作成功',
                    onClose (){
                      self.showChangeNum = false;
                      self.getList();
                    }
                  });
                }else{
                  self.$Message.error(resp.msg);
                }
              });
            } else {
              self.$Message.error('表单校验不通过');
            }
          }catch(err){
            console.log(err);
          }
        })
      },
      changeNumModalCancel(){
        this.showChangeNum = false;
      },
    },
    mounted() {
      this.getList();
    },
    filters: {
      courseTypeFilter: function (value) {
        if (value == 1) {
          return '一对一';
        } else if (value == 2) {
          return '班课';
        } else {
          return '未知:' + value
        }
      },
    },
    computed: {
      courseList() {
        return this.$store.state.app.courseList
      },
    }

  }
</script>
